import { message } from 'antd';
import { Buffer } from "buffer";
import { makeAutoObservable, runInAction } from "mobx";

class AuthStore {

  isAuthenticated: boolean;

  constructor() {
    this.isAuthenticated = localStorage.getItem('user') != null;
    makeAutoObservable(this);
  }


  login(login: string, password: string) {
    // Добавьте код для отправки запроса на сервер для аутентификации
    // И установите this.isAuthenticated в true, если аутентификация прошла успешно
    // this.isAuthenticated = true;
    // localStorage.setItem('user', `{"id":1,"username":"admin"}`);
    // console.log("authStore2: " + this.isAuthenticated);
    // window.location.replace('/');
    try {
      const hash = Buffer.from(`${login}:${password}`).toString('base64');
      const options = {
        method: "POST",
        headers: { 'Authorization': `Basic ${hash}` }
      }

      fetch('/darshana/login', options)
        .then(this.handleLoginResponse)
        .then(
          data => {
            // data = { authenticated: true, user: 'admin' }
            // We pass the `authentication hash` down to the reducer so that it
            // can be used in subsequent API requests.

            runInAction(() => {
              this.isAuthenticated = true;
              localStorage.setItem('user', JSON.stringify(data));
              console.log("authStore2: " + this.isAuthenticated);
              window.location.replace('/');
            });
          },
          (data) => {
            runInAction(() => {
              message.error(`Ошибка при входе: ${data}`);
            });
          }
        )

    } catch (error) {
      runInAction(() => {
        message.error(`Ошибка при входе: ${error}`);
      });
    }
  }

  handleLoginResponse(response: Response) {
    return response.text().then(text => {
      const data = text && JSON.parse(text);
      if (!response.ok) {
        if (response.status === 401) {
          // auto logout if 401 response returned from api
          this.logout();
          // window.location.reload();
        }

        const error = (data && data.message) || response.statusText;
        message.error(`Ошибка при входе: ${error}`);
        return Promise.reject(error);
      }

      return data;
    });
  }

  logout() {
    fetch('/darshana/logout', {method: "POST"})
      .then(this.handleLogoutResponse)
      .then(() => {
        runInAction(() => {
          localStorage.removeItem('user');
          localStorage.removeItem('place');
          this.isAuthenticated = false;
          window.location.replace('/');
        });
      })
        
  }

  handleLogoutResponse(response: Response) {

    return response.text().then(text => {

      const data = text && JSON.parse(text);

      if (!response.ok) {
        const error = (data && data.message) || response.statusText;
        message.error(`Ошибка при выходе: ${error}`);
        return Promise.reject(error);
      }

      return data;
    });
  }
}

export default AuthStore;